import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
// @ts-expect-error FIXME
import connectLogoImage from 'bender-url!../../../images/logo/connect-dot-com-logo.svg';
// @ts-expect-error FIXME
import connectIconImage from 'bender-url!../../../images/logo/connect-dot-com-icon.svg';
// @ts-expect-error FIXME
import connectLogoImageWhite from 'bender-url!../../../images/logo/connect-dot-com-icon-white.svg';
import I18n from 'I18n';
import CUIImage from '../CUIImage/CUIImage';
import { jsx as _jsx } from "react/jsx-runtime";
const CUIConnectLogo = _ref => {
  let {
      use = 'full'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUIImage, Object.assign({
    src: use === 'icon' ? connectIconImage : connectLogoImage,
    alt: I18n.text('connect.logoAltText')
  }, rest));
};
export const CUIConnectIconWhite = _ref2 => {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/_jsx(CUIImage, Object.assign({
    src: connectLogoImageWhite,
    alt: I18n.text('connect.logoAltText')
  }, rest));
};
export default CUIConnectLogo;